<template>
  <div class="cu-row"
       role="button"
       tabindex="0"
       @click="$emit('open', row)"
       @keydown.enter.prevent="$emit('open', row)"
       @keydown.space.prevent="$emit('open', row)">
    <div class="cu-top">
      <b>{{ row.name }}</b>
      <CustomerChip :label="row.chipTh"
                    :tracked="!!row.tracked"
                    :ordered="!!row.ordered" />
    </div>
    <div class="cu-meta">{{ metaLine }}</div>
    <div class="cu-page">{{ row.pageName }}</div>
  </div>
</template>

<script>
import CustomerChip from "@/components/derived/broadcast/CustomerChip";
import { customerMeta } from "@/components/derived/broadcast/customerTime";

// One customer in ลูกค้าที่เคยทักมา: name, chip, "ทัก N ครั้ง · time", Page name. `row` is a list entry of
// GET /api/broadcast/customers. Tapping (or Enter / Space) emits open.
export default {
  name: "CustomerRow",
  components: { CustomerChip },
  props: {
    row: { type: Object, required: true },
  },
  computed: {
    metaLine() {
      return customerMeta(this.row.inboundCount, this.row.lastInboundAt);
    },
  },
};
</script>

<style lang="scss" scoped>
.cu-row {
  padding: 0.75rem 0;
  border-top: 1px solid #eee;
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid $brand-blue-mid;
    outline-offset: 2px;
  }
}

.cu-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;

  b {
    color: #333;
    font-size: 1.05rem;
    min-width: 0;
    overflow-wrap: anywhere;
  }
}

.cu-meta {
  color: #555;
  font-size: 0.9375rem;
  margin-top: 0.15rem;
}

.cu-page {
  color: #767676;
  font-size: 0.8125rem;
}

body.--dark {
  .cu-row {
    border-top-color: #555;
  }

  .cu-top b {
    color: #e6e6e6;
  }

  .cu-meta {
    color: #c4c4c4;
  }

  .cu-page {
    color: #a8a8a8;
  }
}
</style>

